<template>
	<Modal @close="$emit('close')">
		<template v-slot:title>Item Shipment History</template>
		<template v-slot:body>
			<!-- ReportView Mail Modal Width : 800px -->
			<div style="width: 800px;">
				<div class="list_top_box">
					<table class="view_tbl">
						<colgroup>
							<col style="width: 16%;" />
							<col style="width: 17%;" />
							<col style="width: 16%;" />
							<col style="width: 17%;" />
							<col style="width: 16%;" />
							<col style="width: 17%;" />
						</colgroup>
						<tbody>
							<tr>
								<th>Item {{ headers.class }}</th>
								<td>{{ item.class_code }}</td>
								<th>Color</th>
								<td>{{ item.color_code }}</td>
								<th>Item Code</th>
								<td>{{ item.item_code }}</td>
							</tr>
							<tr>
								<th>Vendor Code</th>
								<td>{{ vendor.code }}</td>
								<th>Vendor Name</th>
								<td colspan="3">{{ vendor.name }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="fixed-table-container-none-padding">
					<div class="table-wrapper" style="height: 95%">
						<table class="list_tbl sticky_list_tbl">
							<colgroup>
								<col style="with: 4%;" />
								<col style="with: 32%;" />
								<col style="with: 32%;" />
								<col style="with: 32%;" />
							</colgroup>
							<thead>
								<tr>
									<th>Ord.</th>
									<th>Shipment No.</th>
									<th>Application Date</th>
									<th>Unit Price($)</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(h, idx) in histories" :key="h.sh_item_no">
									<td class="al_center">{{ idx + 1 }}</td>
									<td class="al_center">
										<a class="tbl_pointer" herf="javascript: void(0);" @click="gotoShipment(h.sh_no)">{{ h.sh_dn }}</a>
									</td>
									<td class="al_center">{{ h.application_date }}</td>
									<td class="al_right">{{ h.unit_price | toCurrency3 }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from '@/components/common/Modal';
import { apiItemShipmentHistoryByVendor } from '@/api/purchase/purchase.js';
export default {
	data: () => ({
		item: {},
		vendor: {},
		histories: [],
	}),
	components: {
		Modal,
	},
	props: {
		headers: {
			type: Object,
			default: null,
		},
		item_id: {
			type: String,
			default: null,
		},
		vendor_code: {
			type: String,
			default: null,
		},
	},
	methods: {
		reset() {
			this.item = {};
			this.vendor = {};
			this.histories = [];
		},
		gotoShipment(sh_no) {
			let routeData = this.$router.resolve({ name: 'shipmentDetail', params: { mode: 'detail' }, query: { sh_no } });
			window.open(routeData.href, '_blank');
		},
		async getData() {
			if (!(this.item_id && this.vendor_code)) {
				this.$toast.error('Please, Select Item & Vendor.');
				this.$emit('close');
				return;
			}

			const { data } = await apiItemShipmentHistoryByVendor(this.item_id, this.vendor_code);
			if (data) {
				this.item = data.item;
				this.vendor = data.vendor;
				this.histories = data.histories;
			} else {
				this.reset();
			}
		},
	},
	created() {
		this.getData();
	},
};
</script>

<style></style>
